// app/tools/pubmed-id-converter/[id]/IdPageAnalytics.tsx
//
// Client-side action events for the per-identifier answer pages
// (docs/SEO_STRATEGY.md § "Gate-day plan for 2026-08-28", step 2). The pages
// are static and stay out of funnel_events by design; these are Vercel
// Analytics custom events only. Properties carry our own tool slugs — never
// identifiers, page content, or user input (the event's page path already
// says which PMID page fired it).
"use client";

import { track } from "@vercel/analytics";
import { useEffect } from "react";

// data-idpage-event value → event name. The server component owns the
// data attributes; this component only listens.
const EVENTS: Record<string, string> = {
  copy_citation: "idpage_copy_citation",
  oa_click: "idpage_oa_click",
  tool_click: "idpage_tool_click",
};

export function IdPageAnalytics() {
  useEffect(() => {
    function onClick(event: MouseEvent) {
      const target = event.target instanceof Element ? event.target : null;
      // Only real controls count: a text-selection click inside the citation
      // <pre> must not fire the copy event.
      const actionable = target?.closest("a, button");
      const holder = actionable?.closest("[data-idpage-event]");
      if (!holder) return;
      const name = EVENTS[holder.getAttribute("data-idpage-event") ?? ""];
      if (!name) return;
      // Gated to production like fireFunnel in AuditClient (matches how
      // ClientAnalytics mounts the script; keeps dev/test consoles quiet).
      if (process.env.NODE_ENV !== "production") return;
      const tool = holder.getAttribute("data-idpage-tool");
      track(name, tool ? { tool } : undefined);
    }
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  return null;
}
